import { Component, AfterViewInit, ElementRef, ViewChild , TemplateRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter } from '@angular/material/core';

import { DateRange, MatCalendar } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'app-bi-chart',
    templateUrl: './bi-chart.component.html',
    styleUrl: './bi-chart.component.scss',
    standalone: false
})
export class BiChartComponent implements AfterViewInit {
  ZONE_DESC: string = 'All';
  Dealer_code: string = 'All';
  status: string = 'All';

  selectedButton: any = 'custom';

  private chartbaseUrl: string = environment.chartbaseUrl;
  private chartdashboardId: string = environment.chartdashboardId;
  private dashboard : any = {};
  selectedCardIndex: any = -1;
  isLoading: Subject<boolean> = new Subject<boolean>();

  @ViewChild('dateRangePicker') dateRangePickerTemplate!: TemplateRef<any>;
  

  @ViewChild('dashboardContainer', { static: false }) dashboardContainer!: ElementRef;
  @ViewChild('cancelButton') cancelButton!: ElementRef;
  

    bucketurl = environment.bucketUrl;
    today: Date = new Date(); // Initialize today's date
      startDate: any;
      endDate: any;
      // Set the range
      range: { start: Date | null; end: Date | null } = {
        start: moment().endOf('month').subtract(1, 'week').toDate(),
        end: moment().endOf('month').add(1, 'week').toDate()
      };
    
      // DateRange instance using range
      dateRange = new DateRange(this.range.start, this.range.end);
      @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;

        constructor(public dialog: MatDialog ,  private toastr: ToastrService , private _dateAdapter: DateAdapter<Moment>,) {}
      

    private generateToken(): string {
      let token = sessionStorage.getItem('token') ?? '';  
      return token;
    }

    ngOnInit(){
      this.selectThisMonth();
    }

  async ngAfterViewInit() {
    try {
      const EmbedSDK = (await import('@mongodb-js/charts-embed-dom')).default;
      const sdk = new EmbedSDK({
        baseUrl: this.chartbaseUrl,
        getUserToken: async () => this.generateToken(),
      });

      // const startDateISO = new Date(this.startDate).toISOString();  
      // this.endDate.setMilliseconds(999); 
      // const endDateISO = new Date(this.endDate).toISOString();

      const startDateTime = new Date(this.startDate);
      const endDateTime = new Date(this.endDate);


      // console.log("fddd",new Date(startDateISO) , new Date(endDateISO));
      this.dashboard = sdk.createDashboard({
        dashboardId: this.chartdashboardId,
        width: "100%",
        height: "800px",
        theme: "light",
        filter:{"createdAt": {
          $gte:  this.setStartOfDay(startDateTime),
          $lte: this.setEndOfDay(endDateTime)
        }},
        autoRefresh: true
      });

      // ✅ Render the dashboard inside the container
      await this.dashboard.render(this.dashboardContainer.nativeElement);
    } catch (error) {
      console.error('Error loading MongoDB dashboard:', error);
    }
  }

  setEndOfDay = (date : any) => {
    const newDate = new Date(date);
    newDate.setUTCHours(23, 59, 59, 999);
    return newDate;
  }
  
   setStartOfDay = (date : any) => {
    const newDate = new Date(date);
    newDate.setUTCHours(0, 0, 0, 0);
    return newDate;
  }
  
  async applyFilters(): Promise<void>{
    const ZONE_DESC = (document.getElementById('ZONE_DESC') as HTMLSelectElement).value;
    const REGION_CODE = (document.getElementById('region_code') as HTMLSelectElement).value;
    const AREA = (document.getElementById('area') as HTMLSelectElement).value;
    const DEALER_PARENT = (document.getElementById('dealer_parent') as HTMLSelectElement).value;
    const status = (document.getElementById('status') as HTMLSelectElement).value;
    const Dealer_code = (document.getElementById('Dealer_code') as HTMLInputElement).value; 
    let dashboardFilter: any = {};

    if(ZONE_DESC != '' && ZONE_DESC != 'All'){
        dashboardFilter['outlet_details.zone'] = { $regex: new RegExp('^' + ZONE_DESC.toLowerCase() + '$', 'i') }
        // dashboardFilter['outlet_details.zone'] == ZONE_DESC;
      }

      if(REGION_CODE != ''){
        dashboardFilter['outlet_details.region'] = { $regex: new RegExp('^' + REGION_CODE.toLowerCase() + '$', 'i') }
      }
      if(AREA != ''){
        dashboardFilter['outlet_details.area'] = { $regex: new RegExp('^' + AREA.toLowerCase() + '$', 'i') }
      }
      if(DEALER_PARENT != ''){
        dashboardFilter['outlet_details.parent_dealer'] = { $regex: new RegExp('^' + DEALER_PARENT.toLowerCase() + '$', 'i') }
      }
      if(Dealer_code != ''){
        dashboardFilter['outlet_details.outlet_code'] = { $regex: new RegExp('^' + Dealer_code.toLowerCase() + '$', 'i') }
      }

      if(status != '' && status != 'All'){
        dashboardFilter['current_stage.stage'] = status
      }

      const startDateTime = new Date(this.startDate);
      const endDateTime = new Date(this.endDate);

      //  console.log("dashboardFilter====",this.setStartOfDay(startDateTime) , this.setEndOfDay(endDateTime));
      dashboardFilter['createdAt'] = {
         $gte:  this.setStartOfDay(startDateTime),
          $lte: this.setEndOfDay(endDateTime)
      } 

      // console.log("dashboardFilter====",dashboardFilter);
    try {
      await this.dashboard.setFilter(dashboardFilter);
      // await this.dashboard.setFilter({"outlet_details.zone":ZONE_DESC});
      console.log('Filters applied successfully');
    } catch (error) {
      console.error('Error applying filters:', error);
    }
  }



  // Private
  _startDate: any | null = null;
  _endDate: any | null = null;
  selectedChange(date: any): void {
    if (!this._startDate) {
      this._startDate = date;
    } else if (
      !this._endDate &&
      this._dateAdapter.compareDate(date, this._startDate) >= 0
    ) {
      this._endDate = date;
    } else {
      this._startDate = date;
      this._endDate = null;
    }
    this.dateRange = new DateRange(this._startDate, this._endDate);
    this.startDate = this._startDate;
    this.endDate = this._endDate;
  }

  openDateRangePicker() {
      this.dialog.open(this.dateRangePickerTemplate, { panelClass: 'modal-picker-class' });
      setTimeout(() => {
        if (this.cancelButton) {
          this.cancelButton.nativeElement.focus();
        }
  
      }, 300);
    }
  
  
    selectToday() {
      const today = new Date();
      this.startDate = today;
      this.endDate = today;
      this.selectedButton = 'today';
  
      this.dateRange = new DateRange(this.startDate, this.endDate);
      const selectMonth = new Date();
      selectMonth.setMonth(selectMonth.getMonth());
      if (this.startCalendar) {
        this.startCalendar.activeDate = selectMonth;
      }
    }
  
    selectLast7Days() {
      const today = new Date();
      this.startDate = new Date(today.setDate(today.getDate() - 7));
      this.endDate = new Date();
      this.selectedButton = 'last7';
  
      this.dateRange = new DateRange(this.startDate, this.endDate);
  
  
      const selectMonth = new Date();
      selectMonth.setMonth(selectMonth.getMonth());
      if (this.startCalendar) {
        this.startCalendar.activeDate = selectMonth;
      }
    }
  
    selectLast15Days() {
      const today = new Date();
      this.startDate = new Date(today.setDate(today.getDate() - 15));
      this.endDate = new Date();
      this.selectedButton = 'last15';
      this.dateRange = new DateRange(this.startDate, this.endDate);
  
      const selectMonth = new Date();
      selectMonth.setMonth(selectMonth.getMonth());
      if (this.startCalendar) {
        this.startCalendar.activeDate = selectMonth;
      }
    }
  
    selectThisMonth() {
      this.selectedButton = 'thisMonth';
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.startDate = startOfMonth;
      this.endDate = today;
      this.dateRange = new DateRange(this.startDate, this.endDate);
  
  
      const selectMonth = new Date();
      selectMonth.setMonth(selectMonth.getMonth());
      if (this.startCalendar) {
        this.startCalendar.activeDate = selectMonth;
      }
    }
  
    selectCustom() {
      this.selectedButton = 'custom';
      this.startDate = null;
      this.endDate = null;
      this.dateRange = new DateRange(this.startDate, this.endDate);
    }
  
    onStartDateChange(event: Date) {
      this.startDate = event;
    }
  
    onEndDateChange(event: Date) {
      this.endDate = event;
    }
  
  
    closeDialog() {
      if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
        this.toastr.error("The end date should be greater than or equal to the start date!")
      } else {
        this.dialog.closeAll();
      }
    }
  

    selectedZone: any = {}
    selectCard(index: number, zone: any) {
      if (index != this.selectedCardIndex) {
        this.selectedCardIndex = index; 
      } else {
        this.selectedCardIndex = -1; // Reset the selected index
        this.selectedZone = {}; 
      }
    }

     applyDateRange() {
        this.selectedZone = {};
        this.selectedCardIndex = -1;
        // Logic to apply the date range
        if (this.startDate == null || this.endDate == null) {
          this.toastr.error("Please select a date range!");
        } else {
          if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
            this.toastr.error("The end date should be greater than or equal to the start date!")
          } else {
            this.isLoading = new BehaviorSubject<boolean>(true);
           this.applyFilters();
            this.dialog.closeAll();
          }
        }
      }

  // // Method to toggle between light and dark theme
  // toggleTheme(): void {
  //   const themeCheckbox = document.getElementById('theme') as HTMLInputElement;
  //   this.mongoChartsService.setDashboardTheme(themeCheckbox.checked);
  // } 
}

